import HeaderCard from "../../components/tosan/HeaderCard";
import ContentWrapper from "../../components/tosan/ContentWrapper";
import ServiceLink from "../../components/tosan/ServiceLink";
import billTypes from "../../tools/defaults/tosan/billTypes";
const Services = ["water","tel","mobile","gas","electricity"]

const BillServices = () => {

    return <div className="min-h-screen bg-white">
        <HeaderCard hasBack={false} className="flex justify-center default-header-card flex-col items-center ">
            <h1 className="title">ونش</h1>
        </HeaderCard>
        <ContentWrapper className="flex justify-start ">
            <div className="w-full  ">
                {Services.map((service, index) => {
                    return  <div key={service} className="w-4/12 float-right flex justify-center items-center">
                        <ServiceLink   link={service} className="mt-5 " type={billTypes[service].billType} name={billTypes[service].shortName}
                                     icon={billTypes[service].icon}/>
                    </div>
                })}
            </div>
        </ContentWrapper>
    </div>
}
export default BillServices;